import RenderSummaryHeader from "components/SummaryView/components/RenderSummaryHeader/RenderSummaryHeader"
import React, { useState, useEffect, useRef } from "react"
import { useSelector } from "react-redux"
import Button from "react-bootstrap/Button"
// import { CVP } from "../chemoOrder/InitialValues"
import "./PrintDischargeSummary.scss"
import SurveyComponent from "pages/RMO/components/cancerTemplate/Template"
import { getAllConsultants, getAllDischargeSummary, getCenterDetail, saveDischargeSummary, uploadSpecificFile } from "core/services/api"
import Dropdown from "components/DropDown"
import Toast from "components/Toast"
import moment from "moment"
import PDFViewer from "components/PdfViewer/PdfViewer"
import { generateClinicalSummary, getTestsList } from "core/services/api/patientDiagnosisService"
import PatientDetailsPrintHeader from "components/CommonPrintComponent/PatientDetailsPrintHeader"
import testLabels from "../../../FollowUpVisit/testLabels.json"
import Print from "components/Print/Print"

function PrintDetailedDischargeSummary({ printRef, patient, vitalsData, smartSummaryData, chemoData, selectedOrder, appointmentDischargeId, appointmentDate }: any) {

  const templateJSON = {
    "logoPosition": "right",
    "pages": [
      {
        "name": "page1",
        "elements": [
          {
            "type": "signaturepad",
            "penColor": "black",
            "name": "consultantSign",
            "title": "*Consultant Sign",
            "hideNumber": true,

          },
          {
            "type": "signaturepad",
            "penColor": "black",
            "name": "rmoSign",
            "startWithNewLine": false,
            "title": "*RMO Sign",
            "hideNumber": true,

          },
          {
            "type": "signaturepad",
            "penColor": "black",
            "name": "nurseSign",
            "title": "*Nurse Sign",
            "hideNumber": true,

          },
          {
            "type": "signaturepad",
            "penColor": "black",
            "name": "relativeSign",
            "startWithNewLine": false,
            "title": "*Patient/Relative Sign",
            "hideNumber": true,

          }
        ]
      }
    ],
    "showNavigationButtons": "none",
    "showPageTitles": false,
    "showCompletedPage": false
  }

  const componentRef = useRef(null)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const [signatureJson, setSignatureJson] = useState<any>(templateJSON)
  const [signatureData, setSignatureData] = useState<any>({})
  const [selectedSign, setSelectedSign] = useState<any>()
  const [dischargeData, setDischargeData] = useState<any>({})
  const [consultants, setConsultants] = useState<any>()
  const [consultantOptions, setConsultantOptions] = useState<any>([])
  const [centerDetails, setCenterDetails] = useState<any>({})
  const [displayToast, toggleDisplayToast] = useState<any>(false)
  const [isButtonEnabled, setIsButtonEnabled] = useState<boolean>(false);
  const [responseHtml, setResponse] = useState<any>()
  const divRef = useRef<any>(null)
  //Tests List
  const [testsOptions, setTestsOptions] = useState<any>([])
  //Validation Message For Print
  const [errors, setErrors] = useState<any>("")

  useEffect(() => {
    const centerId = userDetail?.currentCenter?.centerId
    getTestsList(centerId)
      .then((res: any) => {
        const tempOptions = res?.map((each: any) => {
          return { label: each?.serviceName, value: each?.serviceId }
        })
        setTestsOptions(tempOptions)
      })
  }, [])

  useEffect(() => {
    if (userDetail?.currentCenter?.centerId) {
      getCenterDetail(userDetail?.currentCenter?.centerId)
        .then((res: any) => {
          setCenterDetails(res)
        })
        .catch((err: any) => console.log(err?.message))
    }
  }, [userDetail])

  useEffect(() => {
    if (selectedOrder && Object.keys(selectedOrder)?.length > 0) {
      setDischargeData(selectedOrder)
      //Update Signature Data
      updateSignatureData(selectedOrder)
    } else {
      if (patient?.id) {
        getAllDischargeSummary(patient?.id)
          .then((res: any) => {
            setDischargeData(res?.length > 0 ? res[res.length - 1] : {})
            if (res[res?.length - 1] && Object.keys(res[res?.length - 1])?.length > 0) {
              const temp = res[res?.length - 1]
              //Update Signature Data
              updateSignatureData(temp)
            }
          }).catch((err: any) => {
            console.log(err, "err")
          })
      }
    }
  }, [consultants, selectedOrder])

  useEffect(() => {
    fetchConsultants()
  }, [])

  useEffect(() => {
    if (selectedSign) {
      const found = consultants?.find((ele: any) => ele?.name === selectedSign)
      if (found) {
        const values = { ...signatureData }
        values["consultantSign"] = found?.signaturePicUrl
        setSignatureData(values)
      }
    }
  }, [consultants, selectedSign])

  useEffect(() => {
    const creationDate = moment(`${selectedOrder?.dateOfDischarge} ${selectedOrder?.dischargeTimeIn}`, 'YYYY-MM-DD HH:mm')
    const currentDate = moment();
    const hoursDifference = currentDate.diff(creationDate, 'hours');
    if (hoursDifference >= 48) {
      setIsButtonEnabled(true);
    } else {
      setIsButtonEnabled(false)
    }
  }, [])

  useEffect(() => {
    if (isButtonEnabled) {
      const tempJson: any = { ...templateJSON }
      tempJson["pages"][0]["readOnly"] = true
      tempJson["showNavigationButtons"] = "none"
      setSignatureJson(tempJson)
    }
  }, [isButtonEnabled])

  const getTestName = (id: any) => {
    const value = testsOptions?.filter((ele: any) => {
      return ele?.value === Number(id)
    })
    if (value?.length > 0) {
      return value[0]["label"]
    } else {
      return ""
    }
  }

  function fetchConsultants() {
    getAllConsultants(`/consultants?centerId=${userDetail?.currentCenter?.centerId}`)
      .then((res: any) => {
        setConsultants(res)
        const temp = res.map((ele: any) => {
          return ele?.name
        })
        setConsultantOptions(temp)
      })
      .catch((err) => {
        console.log("Err", err)
      })
  }

  const updateSurveyData = (data: any, survey: any) => {
    setSignatureData(data)
  }

  const handleSave = async () => {
    const values = { ...dischargeData }
    const signatureEntries = Object.entries(signatureData)

    await Promise.all(signatureEntries?.map(async ([key, f]: any) => {
      if (!f?.includes("http")) {
        try {
          const response = await fetch(f);
          const data = await response.blob()
          const metadata = {
            type: "image/png"
          };
          const file = new File([data], `${key}.png`, metadata);
          const formData = new FormData()
          formData.append('files', file)

          const uploadedFiles = await uploadSpecificFile(formData, true);
          values[key] = uploadedFiles[0]
        } catch (err: any) {
          values[key] = ""
          const errCode = err?.response?.data?.code
          if (errCode === 'MaxUploadSizeExceededException') {
            toggleDisplayToast({ text: "File Size should be less than 1 MB", type: "warning" })
          }
          console.error("Error in uploading file", err)
        }
      } else {
        values[key] = f
      }
    }))

    saveDischargeData(values)
  }

  const saveDischargeData = (values: any) => {
    saveDischargeSummary(values)
      .then((res: any) => {
        setDischargeData(res)
        //Update Signature Data
        updateSignatureData(res)
        toggleDisplayToast({ text: "Discharge Summary Saved Successfully", type: "success" })
      })
      .catch((err: any) => {
        console.log("err", err)
        toggleDisplayToast({ text: "Unable to Save Discharge Summary ", type: "error" })
      })
  }

  const getReadOnly = () => {
    const creationDate = moment(`${selectedOrder?.dateOfDischarge} ${selectedOrder?.dischargeTimeIn}`, 'YYYY-MM-DD HH:mm')
    const currentDate = moment();
    const hoursDifference = currentDate.diff(creationDate, 'hours');
    if (hoursDifference >= 48) {
      return false
    }
    else if (
      dischargeData?.consultantSign &&
      dischargeData?.nurseSign &&
      dischargeData?.relativeSign &&
      dischargeData?.rmoSign
    ) {
      return false
    } else {
      return true
    }
  }


  const updateSignatureData = (data: any) => {
    const values: any = {}
    let error: any = ""
    if (data?.consultantSign) {
      values["consultantSign"] = data?.consultantSign
      const found = consultants?.find((each: any) => each?.signaturePicUrl === selectedOrder?.consultantSign)
      if (found) {
        setSelectedSign(found?.name)
      }
    } else {
      error += "Consultant Signature"
    }
    if (data?.nurseSign) {
      values["nurseSign"] = data?.nurseSign
    } else {
      error += error?.length > 0 ? ", Nurse Signature" : "Nurse Signature"
    }
    if (data?.relativeSign) {
      values["relativeSign"] = data?.relativeSign
    } else {
      error += error?.length > 0 ? ", Relative Signature" : "Relative Signature"
    }
    if (data?.rmoSign) {
      values["rmoSign"] = data?.rmoSign
    } else {
      error += error?.length > 0 ? ", RMO Signature" : "RMO Signature"
    }
    if (error?.length > 0) {
      error += " required to procced to print"
    }
    if (error?.length > 0) {
      setErrors(error)
    }
    setSignatureData(values)
  }

  const getUrlPdf = () => {
    if (appointmentDischargeId) {
      generateClinicalSummary(appointmentDischargeId, false, true, false)
        .then((res: any) => {
          setResponse(res)
        })
        .catch((err: any) => {
          console.log(err?.message)
        })
    }
  }

  useEffect(() => {
    getUrlPdf()
  }, [appointmentDischargeId])

  useEffect(() => {
    divRef.current.innerHTML = responseHtml;
  }, [responseHtml]);

  return (
    <div>
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => {
            toggleDisplayToast(false)
          }}
          onCloseText="Close"
          onClickText={null}
        />
      )}
      <div className="print-discharge-registration-wrapper"
        ref={componentRef}>
        <section className="header-section">
          <div className="heading">
            <div className="heading-discharge" style={{ color: "#024cf2", paddingBottom: "10px" }}>
              Discharge Summary
            </div>
          </div>
        </section>
        <PatientDetailsPrintHeader
          patientData={{ patientInfo: patient, vitalsData: null }}
          origin="dischargeSummary"
          smartSummaryData={smartSummaryData}
          appointmentDate={appointmentDate}
        />
        {/* Date of admission and discharge */}
        <section className="admission-dates">
          <div className="row" style={{ paddingBottom: "10px" }}>
            <div className="col-6">
              <span className="admission-dates-heading">Date of Admission:</span>&nbsp;
              <span className="admission-dates-value">{moment(dischargeData?.dateOfAdmission).format('DD-MM-YYYY')}</span>
            </div>
            <div className="col">
              <span className="admission-dates-heading">Time In:</span>&nbsp;
              <span className="admission-dates-value">{dischargeData?.admissionTimeIn}</span>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <span className="admission-dates-heading">Date of Discharge:</span>&nbsp;
              <span className="admission-dates-value">{moment(dischargeData?.dateOfDischarge).format('DD-MM-YYYY')
              }</span>
            </div>
            <div className="col-6">
              <span className="admission-dates-heading">Time Out:</span>&nbsp;
              <span className="admission-dates-value">{dischargeData?.dischargeTimeIn}</span>
            </div>
          </div>

        </section>
        {/* Additional Details */}

        <section className="smart-summary">
          <RenderSummaryHeader
            patientDetail={patient}
            smartSummaryData={smartSummaryData}
            origin={"dischargeSummary"}
            page="dischargeSummary"
          />

          <p
            style={{
              fontWeight: '400',
            }}
            className={`course-during-hospital ${!smartSummaryData?.briefHistory ? "print-hidden" : ""}`}
          >
            <span className="course-label">Brief History:</span>
            <ul>
              {
                smartSummaryData?.briefHistory ? (
                  <li style={{ marginBottom: "5px" }} className="textarea-content">{smartSummaryData.briefHistory}</li>
                ) : (
                  <li className="textarea-content">NA</li>
                )
              }
            </ul>
          </p>
        </section>
        <div ref={divRef}></div>
        <div>
          {/* Vitals Details */}
          <section className={`addition ${testLabels?.some((eachKey: any) => vitalsData[`${eachKey?.field}`]) ? "" : "print-hidden"}`}>
            <div className="heading-secondary">Vitals</div>
            <div>
              {
                <ul className="discharge-summary-vitals-wrapper" style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "10px" }}>
                  {
                    testLabels?.map((item: any) => {
                      return (
                        vitalsData[`${item?.field}`] ? (
                          <li style={{ width: "24%" }}>
                            <span className="vitals-label-text">{item?.label} : </span> &nbsp;
                            <span>{vitalsData[`${item?.field}`]} </span>
                            &nbsp;
                            <span>{item?.units}</span>&nbsp;
                          </li>
                        )
                          :
                          (
                            <li style={{ width: "24%" }} className="print-hidden">
                              <span className="vitals-label-text">{item?.label} : </span> &nbsp;
                              NA
                            </li>
                          )
                      )
                    })
                  }
                </ul>
              }
            </div>
          </section>
          {/* Chemo Order Details */}
          <section className="chemo-order">
            <div className="heading-secondary">Chemo Order</div>
            <div className="chemo-order-details">
              {/* Chemo order details for Screen */}
              <div
                className="chemo-extra-details screen-only"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{ width: "100%", display: "flex", gap: "10px" }}
                >
                  {/* <div
                  className={`accordian-details-sub ${!chemoData?.chemoTemplate ? "print-hidden" : ""}`}
                >
                  <div className="details-general-sub-label">
                    Chemo Template:
                  </div>
                  <div className="details-general-sub-value">
                    {chemoData?.chemoTemplate}
                  </div>
                </div> */}
                  <div
                    className={`accordian-details-sub ${!chemoData?.lineOfTreatment ? "print-hidden" : ""}`}
                  >
                    <div className="details-general-sub-label">
                      Line Of Treatment:
                    </div>
                    <div className="details-general-sub-value"> {chemoData?.lineOfTreatment}
                    </div>
                  </div>
                </div>

                <div
                  style={{ width: "100%", display: "flex", gap: "10px" }}
                >
                  <div
                    className={`accordian-details-sub ${!chemoData?.cycleNo ? "print-hidden" : ""}`}
                    style={{ width: "20%" }}
                  >
                    <div className="details-general-sub-label">
                      Cycle No:
                    </div>
                    <div className="details-general-sub-value ">
                      {chemoData?.cycleNo}
                    </div>
                  </div>
                  <div
                    className={`accordian-details-sub ${!chemoData?.week ? "print-hidden" : ""}`}
                    style={{ width: "20%" }}
                  >
                    <div className="details-general-sub-label">
                      Week:
                    </div>
                    <div className="details-general-sub-value ">
                      {chemoData?.week}
                    </div>
                  </div>
                  <div
                    className={`accordian-details-sub ${!chemoData?.day ? "print-hidden" : ""}`}
                  >
                    <div className="details-general-sub-label">
                      Day:
                    </div>
                    <div className="details-general-sub-value ">
                      {chemoData?.day}
                    </div>
                  </div>
                </div>

                <div
                  style={{ width: "100%", display: "flex", gap: "10px" }}
                >
                  <div
                    className={`accordian-details-sub ${!chemoData?.regimen ? "print-hidden" : ""}`}
                  >
                    <div className="details-general-sub-label">Regimen:</div>
                    <div className="details-general-sub-value "> {chemoData?.regimen}</div>
                  </div>
                  <div
                    className={`accordian-details-sub ${!chemoData?.locationDetails ? "print-hidden" : ""}`}
                  >
                    <div className="details-general-sub-label">Location:</div>
                    <div className="details-general-sub-value ">{chemoData?.locationDetails}</div>
                  </div>
                </div>

                <div
                  style={{ width: "100%", display: "flex", gap: "10px" }}
                >
                  <div
                    className={`accordian-details-sub ${!chemoData?.diagnosis ? "print-hidden" : ""}`}
                  >
                    <div className="details-general-sub-label">Diagnosis:</div>
                    <div className="details-general-sub-value ">{chemoData?.diagnosis}</div>
                  </div>
                  <div
                    className={`accordian-details-sub ${!chemoData?.ecogStatus ? "print-hidden" : ""}`}
                  >
                    <div className="details-general-sub-label">ECOG Status:</div>
                    <div className="details-general-sub-value " id="ecogStatus">
                      {
                        chemoData?.ecogStatus?.split(" - ")?.length > 0 ?
                          chemoData?.ecogStatus?.split(" - ")[0]
                          :
                          ""
                      }
                    </div>
                  </div>
                </div>

                <div
                  style={{ width: "100%", display: "flex", gap: "10px" }}
                >
                  <div
                    className={`accordian-details-sub ${!chemoData?.toxicity ? "print-hidden" : ""}`}
                  >
                    <div className="details-general-sub-label">Toxicity:</div>
                    <div className="details-general-sub-value ">{chemoData?.toxicity}</div>
                  </div>
                  <div
                    className={`accordian-details-sub ${!chemoData?.sideEffects ? "print-hidden" : ""}`}
                  >
                    <div className="details-general-sub-label">Side Effects:</div>
                    <div className="details-general-sub-value">
                      {chemoData?.sideEffects}
                    </div>
                  </div>
                </div>

              </div>
              {/* Chemo order details for Print */}
              <div
                className="chemo-extra-details print-only"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                {/* {
                chemoData?.chemoTemplate && (
                  <div
                    className={`accordian-details-sub ${!chemoData?.chemoTemplate ? "print-hidden" : ""}`}

                  >
                    <div className="details-general-sub-label">
                      Chemo Template:
                    </div>
                    <div className="details-general-sub-value">
                      {chemoData?.chemoTemplate}
                    </div>
                  </div>
                )
              } */}
                {
                  chemoData?.lineOfTreatment && (
                    <div
                      className={`accordian-details-sub ${!chemoData?.lineOfTreatment ? "print-hidden" : ""}`}

                    >
                      <div className="details-general-sub-label">
                        Line Of Treatment:
                      </div>
                      <div className="details-general-sub-value "> {chemoData?.lineOfTreatment}
                      </div>
                    </div>
                  )
                }
                {
                  (chemoData?.cycleNo || chemoData?.week || chemoData?.day) && (
                    <div
                      style={{ width: "100%", display: "flex", gap: "10px" }}
                    >
                      {
                        chemoData?.cycleNo && (
                          <div
                            className={`accordian-details-sub ${!chemoData?.cycleNo ? "print-hidden" : ""}`}
                            style={{ width: "20%" }}
                          >
                            <div className="details-general-sub-label">
                              Cycle No:
                            </div>
                            <div className="details-general-sub-value">
                              {chemoData?.cycleNo}
                            </div>
                          </div>
                        )
                      }
                      {
                        chemoData?.week && (
                          <div
                            className={`accordian-details-sub ${!chemoData?.week ? "print-hidden" : ""}`}
                            style={{ width: "20%" }}
                          >
                            <div className="details-general-sub-label">
                              Week:
                            </div>
                            <div className="details-general-sub-value">
                              {chemoData?.week}
                            </div>
                          </div>
                        )
                      }
                      {
                        chemoData?.day && (
                          <div
                            className={`accordian-details-sub ${!chemoData?.day ? "print-hidden" : ""}`}
                          >
                            <div className="details-general-sub-label">
                              Day:
                            </div>
                            <div className="details-general-sub-value">
                              {chemoData?.day}
                            </div>
                          </div>
                        )
                      }
                    </div>
                  )
                }
                {
                  chemoData?.regimen && (
                    <div
                      className={`accordian-details-sub ${!chemoData?.regimen ? "print-hidden" : ""}`}

                    >
                      <div className="details-general-sub-label">Regimen:</div>
                      <div className="details-general-sub-value"> {chemoData?.regimen}</div>
                    </div>
                  )
                }
                {
                  chemoData?.locationDetails && (
                    <div
                      className={`accordian-details-sub ${!chemoData?.locationDetails ? "print-hidden" : ""}`}

                    >
                      <div className="details-general-sub-label">Location:</div>
                      <div className="details-general-sub-value">{chemoData?.locationDetails}</div>
                    </div>
                  )
                }
                {
                  chemoData?.diagnosis && (
                    <div
                      className={`accordian-details-sub ${!chemoData?.diagnosis ? "print-hidden" : ""}`}

                    >
                      <div className="details-general-sub-label">Diagnosis:</div>
                      <div className="details-general-sub-value">{chemoData?.diagnosis}</div>
                    </div>
                  )
                }
                {
                  chemoData?.ecogStatus && (
                    <div
                      className={`accordian-details-sub ${!chemoData?.ecogStatus ? "print-hidden" : ""}`}

                    >
                      <div className="details-general-sub-label">ECOG Status:</div>
                      <div className="details-general-sub-value" id="ecogStatus">
                        {
                          chemoData?.ecogStatus?.split(" - ")?.length > 0 ?
                            chemoData?.ecogStatus?.split(" - ")[0]
                            :
                            ""
                        }
                      </div>
                    </div>
                  )
                }
                {
                  chemoData?.toxicity && (
                    <div
                      className={`accordian-details-sub ${!chemoData?.toxicity ? "print-hidden" : ""}`}

                    >
                      <div className="details-general-sub-label">Toxicity:</div>
                      <div className="details-general-sub-value">{chemoData?.toxicity}</div>
                    </div>
                  )
                }
                {
                  chemoData?.sideEffects && (
                    <div
                      className={`accordian-details-sub ${!chemoData?.sideEffects ? "print-hidden" : ""}`}

                    >
                      <div className="details-general-sub-label">Side Effects:</div>
                      <div className="details-general-sub-value">
                        {chemoData?.sideEffects}
                      </div>
                    </div>
                  )
                }
              </div>
              {/* Start of Prescriptions */}
              <div
                className={`pre-medication-container ${chemoData?.preMedications?.some((outer: any) => {
                  return outer?.medicines?.some((inner: any) => inner?.medicineName);
                }) ? "" : "print-hidden"}`}
              >
                <div className="heading-secondary">Pre Medication</div>
                {
                  chemoData?.preMedications?.map((each: any) => {
                    return (
                      <div className={`${each?.isCancelled ? "print-hidden" : ""}`}>
                        <div className="sub-heading-secondary">Prescription ID: {each?.prescriptionId}</div>
                        <table className="pre-medication-table-container">
                          <thead>
                            <th>Sr.No</th>
                            <th>Type</th>
                            <th>Medicine</th>
                            <th>Dose</th>
                            <th>When</th>
                            <th>Route</th>
                            <th>Notes/Instructions</th>
                            <th>Duration</th>
                            <th>Side Effects
                            </th>
                          </thead>
                          <tbody>
                            {each?.medicines?.map((e: any, index: any) => (
                              <tr className="procedure-data">
                                <td>{index + 1}</td>
                                <td>{e?.type}</td>
                                <td>{e?.medicineName}</td>
                                <td>{e?.dose}</td>
                                <td>{e?.when}</td>
                                <td>{e?.route}</td>
                                <td>{e?.instructions}</td>
                                <td>{e?.duration}</td>
                                <td>
                                  <ul>
                                    {e?.selectedSideEffects?.map(
                                      (sideEffect: any) => {
                                        return <li>{sideEffect}</li>
                                      }
                                    )}
                                  </ul>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )
                  })
                }
              </div>
              <div
                className={`pre-medication-container ${chemoData?.chemotherapyAdministration?.some((outer: any) => {
                  return outer?.medicines?.some((inner: any) => inner?.medicineName);
                }) ? "" : "print-hidden"}`}
              >
                <div className="heading-secondary">ChemoTherapy Administration</div>
                {
                  chemoData?.chemotherapyAdministration?.map((each: any) => {
                    return (
                      <div className={`${each?.isCancelled ? "print-hidden" : ""}`}>
                        <div className="sub-heading-secondary">Prescription ID: {each?.prescriptionId}</div>
                        <table className="pre-medication-table-container">
                          <thead>
                            <th>Sr.No</th>
                            <th>Type</th>
                            <th>Medicine</th>
                            <th>Standard Dose</th>
                            <th>Dose</th>
                            <th>Dose Modification</th>
                            <th>Route</th>
                            <th>Notes/Instructions</th>
                            <th>Duration</th>
                            <th>Side Effects</th>
                          </thead>
                          <tbody>
                            {each?.medicines?.map((item: any, index: any) => (
                              <tr className="procedure-data">
                                <td>{index + 1}</td>
                                <td>{item?.type}</td>
                                <td>{item?.medicineName}</td>
                                <td>{item?.standardDose}</td>
                                <td>{item?.dose}</td>
                                <td>{item?.doseModification}</td>
                                <td>{item?.route}</td>
                                <td>{item?.instructions}</td>
                                <td>{item?.duration}</td>
                                <td>
                                  <ul>
                                    {item?.selectedSideEffects?.map(
                                      (sideEffect: any) => {
                                        return <li>{sideEffect}</li>
                                      }
                                    )}
                                  </ul>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )
                  })
                }

              </div>
              <div
                className={`pre-medication-container ${chemoData?.takeHomeMedicines?.some((outer: any) => {
                  return outer?.medicines?.some((inner: any) => inner?.medicineName);
                }) ? "" : "print-hidden"}`}
              >
                <div className="heading-secondary">Take Home Medicines</div>
                {
                  chemoData?.takeHomeMedicines?.map((each: any) => {
                    return (
                      <div className={`${each?.isCancelled ? "print-hidden" : ""}`}>
                        <div className="sub-heading-secondary">Prescription ID: {each?.prescriptionId}</div>
                        <table className="pre-medication-table-container">
                          <thead>
                            <th>Sr.No</th>
                            <th>Type</th>
                            <th>Medicine</th>
                            <th>Dose</th>
                            <th>When</th>
                            <th>Frequency</th>
                            <th>Duration</th>
                            <th> Notes/Instructions
                            </th>
                            <th>Side Effects</th>
                          </thead>
                          <tbody>
                            {each?.medicines?.map((item: any, index: any) => (
                              <tr className="procedure-data">
                                {/* {JSON.stringify(values)} */}
                                <td>{index + 1}</td>
                                <td>{item?.type}</td>
                                <td>{item?.medicineName}</td>
                                <td>{item?.dose}</td>
                                <td>{item?.when}</td>
                                <td>{item?.frequency}</td>
                                <td>{item?.duration}</td>
                                <td>{item?.instructions}</td>
                                <td>
                                  <ul>
                                    {item?.selectedSideEffects?.map(
                                      (sideEffect: any) => {
                                        return <li>{sideEffect}</li>
                                      }
                                    )}
                                  </ul>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )
                  })
                }
              </div>
              {/* End of Prescriptions */}
            </div>
          </section>
          <section className={`course-during-hospital ${!dischargeData?.courseDuringStay ? "print-hidden" : ""}`}>
            <div className="row">
              <div className="col-3 course-label">Course During Hospital Stay:
              </div>
              <div className="col-1 course-value">{dischargeData?.courseDuringStay}</div>
            </div>
          </section>
          <section className={`course-during-hospital ${!chemoData?.cycleFrequency ? "print-hidden" : ""}`}>
            <div className="row">
              <div className="col-3 course-label">Next Cycle Frequency:
              </div>
              <div className="col-1 course-value">{chemoData?.cycleFrequency}</div>
            </div>
          </section>
          <section className={`course-during-hospital ${!chemoData?.procedureNotes ? "print-hidden" : ""}`}>
            <div className="row">
              <div className="col-3 course-label">Procedure Notes:
              </div>
              <div className="col-1 course-value textarea-content">{chemoData?.procedureNotes}</div>
            </div>
          </section>
          <section className={`course-during-hospital ${!chemoData?.clinicalNotes ? "print-hidden" : ""}`}>
            <div className="row">
              <div className="col-3 course-label">Clinical Notes:
              </div>
              <div className="col-1 course-value textarea-content">{chemoData?.clinicalNotes}</div>
            </div>
          </section>
          <section className={`course-during-hospital ${!chemoData?.followUpDate ? "print-hidden" : ""}`}>
            <div className="row">
              <div className="col-3 course-label">Follow Up Date:
              </div>
              <div className="col-1 course-value">{chemoData?.followUpDate ? moment(chemoData?.followUpDate)?.format('DD-MM-YYYY') : ""}</div>
            </div>
          </section>
          <section className={`course-during-hospital ${!chemoData?.nextCycleOn ? "print-hidden" : ""}`}>
            <div className="row">
              <div className="col-3 course-label">Next Cycle Date:
              </div>
              <div className="col-1 course-value">{chemoData?.nextCycleOn ? moment(chemoData?.nextCycleOn)?.format('DD-MM-YYYY') : ""}</div>
            </div>
          </section>
          <section
            className={`chemo-order ${chemoData?.testsToBeDone?.some((outer: any) => {
              return outer?.tests?.some((inner: any) => inner?.testName);
            }) ? "" : "print-hidden"}`}
          >
            <div className="chemo-order-details">
              <div className="pre-medication-container">
                <div className="heading-secondary">Tests Requested</div>
                {
                  chemoData?.testsToBeDone?.map((eachTest: any) => {
                    return (
                      <div className={`${eachTest?.isCancelled ? "print-hidden" : ""}`}>
                        {/* <div className="heading-secondary">Integration Order ID: {eachTest?.integrationOrderId}</div> */}
                        {
                          eachTest?.tests?.every((eTest: any) => (!eTest?.serviceId) && !eTest?.instructions && !eTest?.when) ?
                            <p className="default-text">NA</p>
                            :
                            <table className="pre-medication-table-container">
                              <thead>
                                <th>Sr.No</th>
                                <th>Test</th>
                                <th>Instructions</th>
                                <th>When</th>
                              </thead>
                              <tbody>
                                {eachTest?.tests?.map((e: any, index: any) => (
                                  <tr className="procedure-data">
                                    {/* {JSON.stringify(values)} */}
                                    <td>{index + 1}</td>
                                    <td>{getTestName(e?.serviceId)}</td>
                                    <td>{e.instructions}</td>
                                    <td>{e.when}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                        }
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </section>
          <div className="disclaimer-signature-container">
            <section className="course-during-hospital">
              <div className="heading-secondary-disclaimer">Disclaimer</div>
              <div className="row">
                <div className="end-disclaimer">1. The patient and relatives have been explained the side effects and risks associated with chemotherapy in the language best understood by them, and consent has been taken prior to the administration of chemotherapy.</div>
              </div>
              <div className="row">
                <div className="end-disclaimer">2. All the procedures and take-home medication have been explained to the patient and the relative in the language best understood by them.</div>
              </div>
            </section>
            <section className="signature-container">
              <div className="heading-secondary-signature">Consultant Signature</div>
              <Dropdown
                className={"consultant-signature-dropdown"}
                selected={selectedSign}
                placeholder="Select Consultant Signature"
                options={consultantOptions}
                disable={isButtonEnabled}
                updateDropdown={(option: any) => setSelectedSign(option)}
              />
              <SurveyComponent
                css={""}
                data={signatureData}
                json={signatureJson}
                onComplete={(survey: any) => {
                  const data = survey.data
                  setSignatureData(data)
                  // handleSurveyCompletion()
                }}
                updateFlag={updateSurveyData}
                hideDot={true}
              />
            </section>
          </div>
          <div className="disclaimer-signature-container">
            <div className="end-disclaimer">This has been explained to the patient/relative in the language best understood by them. For emergency please call on RMO</div>
            <PDFViewer url={centerDetails?.accessCareProtocol?.blobUrl} />
          </div>
        </div>
      </div>
      <div>
        {
          errors && <div style={{ textAlign: "center", color: "red", marginTop: "20px" }}>{errors}</div>
        }
        <div className="print-btn">
          <Button size="lg" disabled={isButtonEnabled} onClick={() => handleSave()}>Save</Button>
          <Print
            componentRef={componentRef}
            buttonTitle='Print Discharge Summary'
            documentTitle={`Discharge Summary ${patient.mocId} ${patient.name}`}
            disabled={getReadOnly()}
            size="lg"
          />
        </div>
      </div>
    </div>
  )
}

export default PrintDetailedDischargeSummary